/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GoalTypeSumList = {
    type: 'array',
    contains: {
        type: 'GoalTypeSum',
    },
} as const;
